import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { LoadingManager } from "three";

const useDracoLoader = (url: string, loadingManager?: LoadingManager) => {
    const state = useLoader(GLTFLoader, url, loader => {
        if (loadingManager) {
            loader.manager = loadingManager;
        }
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.6/");
        dracoLoader.setDecoderConfig({ type: "js" });
        loader.setDRACOLoader(dracoLoader);
    });
    return state;
};

export default useDracoLoader;
